/*
 * @Author: zhangzhitao
 * @Date: 2019-10-22 09:35:42
 * @LastEditors: zhangzhitao
 * @LastEditTime: 2019-12-03 12:04:11
 * @Description:
 */
import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions-portal'
import * as getters from './getters'

Vue.use(Vuex)

const state = {
  userInfo: null,
  navigateSchema: 'nav-type1',
  appMenus: null,
  systemMenus: null,
  personalMenus: null,
  tabMenus: [],
  navTabMenus: [], // 导航标签使用，于之前tabMenus解耦
  activeTabMenu: '',
  userName: '',
  todoMenuId: '',
  messageMenuId: '',
  extendData: {},
  basicInfo: {},
  viewType: 'home'
}

export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
  modules: {}
})
